import { isEqual, isNull, isUndefined } from 'lodash-es';
import { TripSearchRequest } from '../models';
import { PlaceAutocompleteModelDto } from '@/types/webapi';

export function isKindaEqual(
    value: TripSearchRequest & { fromPlace: PlaceAutocompleteModelDto | null; toPlace: PlaceAutocompleteModelDto | null },
    oldValue: TripSearchRequest & { fromPlace: PlaceAutocompleteModelDto | null; toPlace: PlaceAutocompleteModelDto | null }
) {
    if (!isUndefined(value) && !isUndefined(oldValue) && !isNull(value) && !isNull(oldValue)) {
        const { fromPlace, toPlace, ...props } = value;
        const { fromPlace: oldFromPlace, toPlace: oldToPlace, ...oldProps } = oldValue;

        return isEqual(
            { fromPlace: fromPlace?.id, toPlace: toPlace?.id, ...props },
            { fromPlace: oldFromPlace?.id, toPlace: oldToPlace?.id, ...oldProps }
        );
    }

    return isEqual(value, oldValue);
}
